import * as api from '../api'

export const getChartDetails = (chart, params) => {
  return new Promise((resolve, reject) => {
    return api
      .get('/reports/' + chart + '/', { params })
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}
